import type { Phrases } from '../Phrases.d';

import {
	type ColorName,
	COLOR_NAME,
} from '../constants';


export const getTranslatedColors = ({
	phrases,
}: {
	phrases: Phrases
}): Record<ColorName, string> => ({
	[COLOR_NAME.BLACK]: phrases['notificationForm.common.colorField.value.black'],
	[COLOR_NAME.BLUE]: phrases['notificationForm.common.colorField.value.blue'],
	[COLOR_NAME.BROWN]: phrases['notificationForm.common.colorField.value.brown'],
	[COLOR_NAME.GOLD]: phrases['notificationForm.common.colorField.value.gold'],
	[COLOR_NAME.GRAY]: phrases['notificationForm.common.colorField.value.gray'],
	[COLOR_NAME.GREEN]: phrases['notificationForm.common.colorField.value.green'],
	[COLOR_NAME.LIGHT_BROWN]: phrases['notificationForm.common.colorField.value.lightBrown'],
	[COLOR_NAME.LIGHT_GRAY]: phrases['notificationForm.common.colorField.value.lightGray'],
	[COLOR_NAME.ORANGE]: phrases['notificationForm.common.colorField.value.orange'],
	[COLOR_NAME.OTHER]: phrases['notificationForm.common.colorField.value.other'],
	[COLOR_NAME.PALE_GOLDENROD]: phrases['notificationForm.common.colorField.value.paleGoldenrod'],
	[COLOR_NAME.PINK]: phrases['notificationForm.common.colorField.value.pink'],
	[COLOR_NAME.PURPLE]: phrases['notificationForm.common.colorField.value.purple'],
	[COLOR_NAME.RED]: phrases['notificationForm.common.colorField.value.red'],
	[COLOR_NAME.TRANSPARENT]: phrases['notificationForm.common.colorField.value.transparent'],
	[COLOR_NAME.TURQUOISE]: phrases['notificationForm.common.colorField.value.turquoise'],
	[COLOR_NAME.WHITE]: phrases['notificationForm.common.colorField.value.white'],
	[COLOR_NAME.YELLOW]: phrases['notificationForm.common.colorField.value.yellow'],
});
